import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import Select, { SingleValue } from "react-select";

import { Modal } from "./common/modal/Modal";
import { FooterModal } from "./common/modal/Footer";
import { Body } from "./common/modal/Body";
import { HeaderModal } from "./common/modal/Header";

import allImgPaths from "assets/images";
import { format } from "date-fns";
import { getEventTaskList, updateTask } from "services/event";
import useAppState from "context/useAppState";
import { useParams } from "react-router-dom";

type taskDropDown = {
  value: string;
  label: string;
};

type formDataType = {
  task: string;
  remainderData: number;
};
const FeteAddRemainder = () => {
  const params: any = useParams();
  const [startDate, setStartDate] = useState<Date>(new Date());
  const [taskDropDownValue, setTaskDropDownValue] = useState<taskDropDown | null>();
  const [formData, setFormData] = useState<formDataType>({
    task: "",
    remainderData: parseInt(format(new Date(), "T")),
  });
  const [dropDownOptions, setDropDownOptions] = useState<taskDropDown[]>([]);
  const [showError, setShowError] = useState<boolean>(false); // State to manage error message visibility

  const { selectedCardDetail, updateBoardCallApiFlag } = useAppState("cardWrapper");
  const { showRemainderModal, setState: setChatBoxState, state } = useAppState("chatBox");

  useEffect(() => {
    if (showRemainderModal && selectedCardDetail) {
      const { block_id, id } = selectedCardDetail;

      (async () => {
        const { data } = await getEventTaskList(params?.id, block_id, id);

        const modifiedOptions = data[0].tasks.map((task: any) => ({
          value: task._id,
          label: task.title,
        }));

        // Add "Main" option
        modifiedOptions.unshift({ value: "main", label: "Main" });

        setDropDownOptions(modifiedOptions);
      })();
    }
  }, [showRemainderModal]);

  const customSelectStyle = {
    singleValue: (styles: any) => ({
      ...styles,
      color: "#344054",
    }),
    valueContainer: (styles: any) => ({
      ...styles,
      backgroundColor: "#fff",
      padding: "0px 0px 0px 5px",
      fontSize: "14px",
      cursor: "pointer",
    }),
    control: (styles: any) => ({
      ...styles,
      backgroundColor: "#fff",
      padding: "4px 12px",
      borderRadius: "8px",
      cursor: "pointer",
      boxShadow: "0",
      "&:hover": {
        border: "1px solid #D0D5DD",
      },
    }),
    indicatorContainer: (styles: any) => ({
      ...styles,
      padding: "0px 0px",
    }),
    indicatorSeparator: (styles: any) => ({ ...styles, display: "none" }),
    dropdownIndicator: (styles: any) => ({
      ...styles,
      color: "#85888E",
      cursor: "pointer",
      "&:hover": { color: "#85888E" },
      paddingRight: "0px",
    }),
    menu: (styles: any) => ({
      ...styles,
      left: "0",
      boxShadow:
        "0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10)",
      backgroundColor: "#fff",
      borderRadius: "12px",
      margin: "0px",
      overflow: "hidden",
    }),
    menuList: (styles: any) => ({
      ...styles,
      backgroundColor: "#fff",
      maxHeight: "192px",
      padding: "4px 4px",
    }),
    option: (styles: any, { isFocused }: any) => ({
      ...styles,
      cursor: "pointer",
      fontSize: "15px",
      fontWeight: "500",
      color: "#344054",
      padding: "6px 6px 6px 6px",
      borderRadius: "4px",
      marginBottom: "4px",
      backgroundColor: isFocused ? "#fff" : "#fff",
      "&:active": { color: "#1e0af5", backgroundColor: '#fff' },
      "&:hover": { color: "#1e0af5" }
    }),
    placeholder: (styles: any) => ({
      ...styles,
      fontWeight: "500",
      fontSize: "16px",
    }),
  };

  const postData = async () => {
    const payload = {
      reminder_date: formData.remainderData,
      task_id: formData.task,
      // block_id: selectedCardDetail.block_id,
      block_id: selectedCardDetail?.columnId || selectedCardDetail?.block_id,
      card_id: selectedCardDetail.id,
    };

    const response = await updateTask(params?.id, payload);
    updateBoardCallApiFlag(true);
    setTaskDropDownValue(null);
    setDropDownOptions([]);
    setChatBoxState({ ...state, showRemainderModal: false });
  };

  const handleDateChange = (options: any) => {
    setStartDate(options);
    setFormData({ ...formData, remainderData: parseInt(format(options, "T")) });
  };

  const handleDropDownChange = (selectedValue: SingleValue<taskDropDown>) => {
    if (selectedValue !== null) {
      setTaskDropDownValue(selectedValue);
      setFormData({ ...formData, task: selectedValue.value });
      setShowError(false); // Hide error message when dropdown value is selected
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!taskDropDownValue) {
      // If dropdown value is not selected, show error message
      setShowError(true);
      return;
    }
    postData();
  };

  return (
    <>
      <Modal className={"modal-wrapper max-w-[480px]"} isShow={showRemainderModal}>
        <form onSubmit={handleSubmit}>
          <HeaderModal
            title=""
            isShowHeader={true}
            className="modal-header pt-6 px-6 pb-5 border-b border-[#EAECF0]"
          >
            <div className="flex items-center justify-between">
              <div className="flex justify-center items-center gap-x-4">
                <img className="top-0.5 left-0 object-contain -z-10" src={allImgPaths.addReminderDateBg} alt="" />
                <h2 className="text-lg text-[#101828] font-interSemiBold leading-none pb-1.5">
                  Add Reminder Date
                </h2>
              </div>
              {/* Close Icon */}
              <img
                className="modal-close modal-toggle cursor-pointer hover:bg-[#F2F4F7] rounded w-5 p-1 -mt-6"
                id="modal-toggle"
                src={allImgPaths.closeIcon}
                onClick={() => setChatBoxState({ ...state, showRemainderModal: false })}
                alt="close icon"
              />
            </div>
          </HeaderModal>

          <Body
            title=""
            isShowBody={true}
            className="modal-body px-6 pt-5 overflow-x-auto due-modal"
          >
            <div className="mb-6">
              <div className="custom-datepicker modal-date-picker w-full">
                <ReactDatePicker
                  startDate={startDate}
                  inline
                  onChange={handleDateChange}
                  minDate={new Date()}
                  showDisabledMonthNavigation
                  className="custom-datepicker-input placeholder:text-[#667085] placeholder:text-base text-base text-[#344054] w-full"
                />
              </div>

              <div className="relative w-full pt-1">
                <p className="text-[#344054] text-sm font-interMedium pb-2">Apply to task</p>
                {/* {dropDownOptions?.length > 0 ? ( */}
                <Select
                  value={taskDropDownValue}
                  onChange={handleDropDownChange}
                  options={dropDownOptions}
                  isSearchable={true}
                  placeholder="Select"
                  className="multi-select-wrapper placeholder:text-[#344054] placeholder:text-base text-base text-[#344054]"
                  classNamePrefix="select"
                  styles={customSelectStyle}
                />
                {/* ) : (
                  <p>Loading options...</p>
                )} */}
                {showError && <p className="text-red-500">Please select a task</p>}
              </div>
            </div>
          </Body>

          <FooterModal
            title=""
            isShowFooter={true}
            className="modal-footer pt-4 px-6 pb-4 border-t border-[#EAECF0]"
          >
            <div className="flex items-center gap-x-3 justify-end">
              <button onClick={() => setChatBoxState({ ...state, showRemainderModal: false })} className="text-[#344054] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-2.5 !text-base hover:bg-[#F2F4F7] w-40">Cancel</button>
              <button
                type="submit"
                className={`!text-base text-white bg-[#1E0AF5] hover:bg-[#120693] font-interSemiBold rounded-lg  px-3.5 py-2.5 w-40 ${!formData?.task ? 'button-disabled' : ''}`}
              >
                Add Reminder
              </button>
            </div>
          </FooterModal>
        </form>
      </Modal>
    </>
  );
};

export default FeteAddRemainder;
